import {
  mockCardPaymentOption,
  mockRenewalDetails,
} from '@domgen/dgx-fe-basket';
import { CompletedRenewalDetails } from '../../models/completed-renewal/completed-renewal-details.interface';
import { mockCheckoutCompletedRenewalConfirmation } from '../checkout-completed-item/checkout-completed-renewal-confirmation.mock';

export const mockCompletedRenewalDetails: CompletedRenewalDetails = {
  ...mockRenewalDetails,
  ...mockCheckoutCompletedRenewalConfirmation,
  purchasedPaymentOption: mockCardPaymentOption,
};
